const address = (state = {}, action) => {
  switch (action.type) {
    case 'SET_NEW_ADDRESS': {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default address;
